import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let ga4Initialized = false;

// Initialize GA4 dynamically from site settings
export async function initGA4() {
  if (ga4Initialized) return;
  try {
    const r = await axios.get(`${API}/site-settings`);
    const gid = r.data?.ga4_id;
    if (!gid) return;
    
    // Load gtag script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gid}`;
    document.head.appendChild(script);
    
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', gid, { send_page_view: false });
    ga4Initialized = true;
    console.log(`GA4 initialized: ${gid}`);
  } catch (e) {}
}

// Track page views
export function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title
      });
    }
  }, [location]);
}

// Track events (inquiry form, contact clicks, etc.)
export function trackEvent(eventName, params = {}) {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
}
